import { Button, Divider, Grid } from '@material-ui/core';
import React from 'react';
import Ws from '../../providers/Ws';


const FinalizeazaBilant = (props) => {


    const ws = new Ws()



    const finalizeaza = () =>{
        console.log('finalizeaza TODO')

        props.history.push('/diagnosticfinanciar')
    }


    const addClienti =async ()=>{
        console.log('add clienti TODO')

        console.log('props.bilant :>> ', props.bilant);

        let insertClientiH = await ws.insert('fin_import_raport_lunar_clienti_head', { an: props.bilant.an, luna: 12 })

        if(insertClientiH.Succes){
            props.history.push(`/clientirows/${insertClientiH.Content[0].id}`)
        }

  
    }



    return (

        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container>
                    <Grid  item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h4 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, color:'rgb(151	203	76)', fontSize:18 }} > {props.dictionary.financiar.aiTerminat}</h4>

                        <Divider className="pm-divider" />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid container>
                            <Grid style={{textAlign:'left', marginBottom:20, marginTop:20}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <span style={{ fontSize: 16 }}>{props.dictionary.financiar.felicitariBilant}! </span>
                            </Grid>

                            <Grid style={{textAlign:'left', marginBottom:20}}  item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <span style={{ fontSize: 16 }}>{props.dictionary.financiar.apasaFinalizeaza}  </span>
                            </Grid>

                        </Grid>

                        <Divider className="pm-divider" />

                    </Grid>

                    <Grid style={{marginTop:20, textAlign:'left'}} item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Button
                            style={{ marginRight: 20 }}

                            className={'add-button-green'} onClick={finalizeaza}  >

                        {props.dictionary.financiar.finalizeaza}
                        </Button>

                        <Button
                            style={{ marginRight: 20 }}

                            className={'add-button-blue'} onClick={addClienti}  >

                            <i style={{
                                fontSize: 14,
                                marginRight: 10
                            }} className='material-icons'>add</i>  {props.dictionary.financiar.adaugaClienti}
                        </Button>

                    </Grid>


                </Grid>

            
            </Grid>

        </Grid>
    )


}


export default FinalizeazaBilant;